import React, { Component } from 'react';
import Formulario from './PersonalExternoForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

class PersonalExterno extends Component{
    state = {
        crear: true,
    }

    componentDidMount = () => {
        const { match, leer, getModulo, getPais } = this.props;
        const id = match.params.id;
        if (id){
            this.setState({crear: false});
            leer(id);
        }
        let ruta = window.location.href;
        let modulo = ruta.split('/');
        getModulo(modulo[5],modulo[4])
        getPais(modulo[8]);
    }
    
    render(){
        const { registroPersonal, modificarPersonal, loader, modulo, paisN } = this.props;
        const { crear } = this.state;
        const funcionEnvio = crear ? registroPersonal : modificarPersonal;
        return(
            <LoadMask loading={loader} dark>
                <Formulario
                    onSubmit = {funcionEnvio}
                    crear = {crear}
                    modulo = {modulo}
                    paisN = {paisN}
                />
            </LoadMask>
        );
    }
}


export default PersonalExterno;